import React from 'react';
import { node } from 'prop-types';

import CircularProgress from '@material-ui/core/CircularProgress';

import defaultClasses from './TabContentProgress.module.css';

const TabContentProgress = ({ children, ...props }) => (
    <aside className={defaultClasses.root}>
        <div className={defaultClasses.label}>
            <CircularProgress {...props} />
            {children}
        </div>
    </aside>
);

TabContentProgress.defaultProps = {
    children: 'Loading...'
};

TabContentProgress.propTypes = {
    children: node
};

export default TabContentProgress;
